import Utils from './common/Utils';
import Footer from './footer/footer.common';

class App {
	constructor(_config = {}) {
		this.footer = new Footer(_config);
	}
}

Utils.namespace('nc.footer');
let ncFooter = new App();
